import React, { useEffect, useState } from "react";
import { GoogleMap, Marker, LoadScript, } from "@react-google-maps/api";
import classes from "./Mapa.module.scss";
import SearchBox from "./SearchBox";
import { FormButton } from "components";
import { GOOGLE_MAP_KEY } from "consts/env";

const containerStyle = {
    width: "100%",
    height: "300px",
    marginBottom: "1rem",
};

const libraries = ["places"];
export default function ModalMapa({
    latitud,
    longitud,
    calle,
    numero,
    localidad,
    provincia,
    pais,
    cod,
    onSetCoordenadas,
    closeModal = () => { } }) {
    const initialPos = {
        lat: latitud ? (typeof latitud === "number" ? latitud : parseFloat(latitud)) : -32.9587,
        lng: longitud ? (typeof longitud === "number" ? longitud : parseFloat(longitud)) : -60.6645,
    };

    const [markerPos, setMarkerPos] = useState(initialPos);
    const [coordenadas, setCoordenadas] = useState(initialPos);
    const [direccion, setDireccion] = useState('');
    const [capturedData, setCapturedData] = useState({
        calle: calle || '',
        numero: numero || '',
        localidad: localidad || '',
        cod: cod || '',
    });

    useEffect(() => {
        const latn = latitud !== undefined && latitud !== null
            ? (typeof latitud === 'number' ? latitud : parseFloat(latitud))
            : null;
        const lngn = longitud !== undefined && longitud !== null
            ? (typeof longitud === 'number' ? longitud : parseFloat(longitud))
            : null;

        console.log('ModalMapa - props changed:', { latitud: latn, longitud: lngn });

        let mounted = true;
        let timer = null;

        if (latn != null && lngn != null) {
            timer = setTimeout(() => {
                if (!mounted) return;
                const sameLat = markerPos && Number(markerPos.lat).toFixed(6) === Number(latn).toFixed(6);
                const sameLng = markerPos && Number(markerPos.lng).toFixed(6) === Number(lngn).toFixed(6);
                if (!sameLat || !sameLng) {
                    setMarkerPos({ lat: latn, lng: lngn });
                    setCoordenadas({ lat: latn, lng: lngn });
                }
            }, 400);
        }

        return () => {
            mounted = false;
            if (timer) clearTimeout(timer);
        };
    }, [latitud, longitud]);


    useEffect(() => {
        setDireccion(`${calle ?? ''} ${numero ?? ''}${localidad ? `, ${localidad}` : ''}${provincia ? `, ${provincia}` : ''}${pais ? `, ${pais}` : ''}`)
    }, [calle, localidad, numero, pais, provincia])

    const handleClick = (event) => {
        event.preventDefault();

        // Si capturedData está vacío, usa los props iniciales
        const dataToSend = {
            latitud: markerPos.lat,
            longitud: markerPos.lng,
            calle: capturedData.calle || calle || '',
            numero: capturedData.numero || numero || '',
            localidad: capturedData.localidad || localidad || '',
            cod: capturedData.cod || cod || ''
        };

        console.log('Enviando al insert:', dataToSend);
        onSetCoordenadas(dataToSend);
        closeModal();
    };

    const handleSearchSelect = (data) => {
        const coords = { lat: data.lat, lng: data.lng };
        setCoordenadas(coords);
        setMarkerPos(coords);
        setCapturedData({
            calle: data.calle || '',
            numero: data.numero || '',
            localidad: data.localidad || '',
            cod: data.cod || ''
        });
    };

    return (
        <div className={classes.mapaModal}>
            <LoadScript
                id="second-google-map-script"
                googleMapsApiKey={`${GOOGLE_MAP_KEY}`}
                libraries={libraries}
            >
                <SearchBox
                    coordenadas={coordenadas}
                    onSetCoordenadas={handleSearchSelect}
                    direccion={direccion}
                />
                <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={coordenadas}
                    zoom={14}
                    onClick={(e) =>
                        setCoordenadas({
                            lat: e.latLng.lat(),
                            lng: e.latLng.lng(),
                        })
                    }
                >
                    <Marker
                        position={markerPos}
                        draggable={true}
                        onDragEnd={(e) => {
                            const newLat = e.latLng.lat();
                            const newLng = e.latLng.lng();
                            setMarkerPos({ lat: newLat, lng: newLng });

                            const geocoder = new window.google.maps.Geocoder();
                            geocoder.geocode({ location: { lat: newLat, lng: newLng } }, (results, status) => {
                                if (status === "OK" && results[0]) {
                                    const addressComponents = results[0].address_components;

                                    const streetName = addressComponents.find(c => c.types.includes("route"))?.long_name;
                                    const streetNumber = addressComponents.find(c => c.types.includes("street_number"))?.long_name;
                                    const postalCode = addressComponents.find(c => c.types.includes("postal_code"))?.long_name;

                                    // Buscamos localidad en varios posibles campos de Google
                                    const city = addressComponents.find(c => c.types.includes("locality"))?.long_name ||
                                        addressComponents.find(c => c.types.includes("administrative_area_level_2"))?.long_name ||
                                        addressComponents.find(c => c.types.includes("sublocality"))?.long_name;

                                    const nuevaDireccion = `${streetName || ''} ${streetNumber || ''}${city ? `, ${city}` : ''}`.trim();
                                    setDireccion(nuevaDireccion);
                                    setCapturedData({
                                        calle: streetName || '',
                                        numero: streetNumber || '',
                                        localidad: city || '',
                                        cod: postalCode || ''
                                    });
                                    console.log("--- Datos Geográficos Capturados ---");
                                    console.log("Calle:", streetName || "No encontrada");
                                    console.log("Altura:", streetNumber || "S/N");
                                    console.log("Localidad:", city || "No encontrada");
                                    console.log("CP:", postalCode || "No encontrado");
                                    console.log("Lat:", newLat, "Lng:", newLng);
                                }
                            });
                        }}
                    />
                </GoogleMap>
                <FormButton
                    onClick={handleClick}
                    onSecondaryClick={closeModal}
                    newFormData={{ button: "Confirmar" }}
                />
            </LoadScript>
        </div>
    );
}
